<template>
  <div class="background">
    <HeaderHome :user="this.$store.state.user.prenom" />
    <div class="greeting">
      <h1>Liste des élèves</h1>
      <p>Proposer un élève à l'examen ou voir les élèves déjà proposés</p>
    </div>

    <div class="eleves-mono">
      <SimpleTypeahead
        id="typeahead_id"
        placeholder="Rechercher un élève..."
        :items="leleves"
        :minInputLength="1"
        :itemProjection="
          (item) => {
            return item.fullname;
          }
        "
        @selectItem="selectItem"
        @onInput="searchEleve"
      >
      </SimpleTypeahead>
      <template v-if="this.eleveSelec !== ''">
        <div class="eleveSelec">
          <p v-if="eleveSelec.aac === true">AAC</p>
          <p v-else>B</p>
          <p>Code : {{ eleveSelec.exCode }}</p>
          <p v-if="eleveSelec.acc === true">ACC</p>
          <p>{{ eleveSelec.niveau }}</p>
          <p>{{ eleveSelec.solde }}</p>
          <button @click="this.eleveSelec = ''" class="btn btn-danger">
            X
          </button>
        </div>
        <template v-if="this.eleveSelec.demande === false">
          <template v-if="eleveSelec.dateProba === ''">
            <MultiSelect
              class="mutltiSelectLieux"
              v-model="lieu"
              :options="lieux"
              optionValue="id"
              optionLabel="nom"
              placeholder="Lieux d'examen"
              :disabled="desac"
            />
            <br />
            <br />

            <button
              class="btn btn-primary"
              @click="setDemande('null')"
              v-if="loadBtn === false"
            >
              PROPOSER A L'EXAMEN
            </button>
            <button
              class="btn btn-primary"
              @click="setDemande('null')"
              v-else
              disabled
            >
              <span
                ><i class="fa fa-spinner fa-spin"></i>PROPOSER A L'EXAMEN</span
              >
            </button>
          </template>
          <template v-else>
            <p>
              Cet élève doit attendre le {{ eleveSelec.laDateProba }} avant de normalement
              pouvoir refaire une demande.
            </p>

            <MultiSelect
              class="mutltiSelectLieux"
              v-model="lieu"
              :options="lieux"
              optionValue="id"
              optionLabel="nom"
              placeholder="Lieux d'examen"
              :disabled="desac"
            />
            <br />
            <br />

            <button
              class="btn btn-primary"
              @click="setDemande('null')"
              v-if="loadBtn === false"
            >
              PROPOSER A L'EXAMEN
            </button>
            <button
              class="btn btn-primary"
              @click="setDemande('null')"
              v-else
              disabled
            >
              <span
                ><i class="fa fa-spinner fa-spin"></i>PROPOSER A L'EXAMEN</span
              >
            </button>
          </template>
        </template>
      </template>
      <template v-else>
        <DataTable
          :value="eleves"
          paginator
          :rows="5"
          :rowsPerPageOptions="[5, 10, 20, 50]"
        >
          <Column field="nom" header="Nom"></Column>
          <Column field="prenom" header="Prenom"></Column>
          <Column field="niveau" header="Niveau"></Column>
          <Column field="eb" header="Eb"></Column>
          <Column field="exam" header="Exam"></Column>
          <Column field="lieu" header="Lieu"></Column>
        </DataTable>
      </template>
    </div>
  </div>
</template>

<script>
import SimpleTypeahead from "vue3-simple-typeahead";
import HeaderHome from "../../components/home/HeaderHome.vue";
export default {
  props: [],

  components: {
    SimpleTypeahead,
    HeaderHome,
  },

  watch: {},

  data() {
    return {
      eleves: [],
      leleves: [],
      eleveSelec: "",
      lieux: [],
      lieu: "",
      loadBtn: false,
    };
  },

  mounted() {
    this.getElevesExamByMono();
    this.getLieuBoite();
  },

  methods: {
    setDemande(type) {
      this.loadBtn = true;

      if (this.lieu === "") {
        alert("Veuillez choisir un lieu");
        this.loadBtn = false;
      } else {
        if (
          window.confirm(
            "Êtes-vous sûr de demander une date d'examen pour cet élève ?",
          )
        ) {
          window.api
            .get("/can/demande/" + this.eleveSelec.id, {
              headers: {
                Authorization: "Bearer " + this.$store.state.token,
              },
            })
            .then((response) => {
              if (response.data.demande === false) {
                alert(
                  "L'élève n'a pas un solde suffisant pour pouvoir demander une date d'examen, il doit avoir au minimum " +
                    response.data.limite +
                    "€ en solde. Veuillez contacter votre agence",
                );
                this.loadBtn = false;
              } else {
                window.api
                  .post(
                    "/set/demande/exam/" + type + "/null",
                    {
                      id: this.eleveSelec.id,
                      ids: this.$store.state.user.id,
                      idMono: this.$store.state.user.idMono,
                      lieu: this.lieu,
                      commentaire: "",
                    },
                    {
                      headers: {
                        Authorization: "Bearer " + this.$store.state.token,
                      },
                    },
                  )
                  .then(() => {
                    this.loadBtn = false;
                    window.location.reload();
                  })
                  .catch((error) => {
                    console.log(error);
                  });
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          this.loadBtn = false;
        }
      }
    },

    getLieuBoite() {
      window.api
        .get("/boite/lieu/exam/", {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          },
        })
        .then((response) => {
          this.lieux = response.data.lieux;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    searchEleve(e) {
      if (
        e.input.length == 3 ||
        e.input.length == 6 ||
        e.input.length == 9 ||
        e.input.length == 12 ||
        e.input.length == 15 ||
        e.input.length == 18 ||
        e.input.length == 21
      ) {
        window.api
          .get("/eleves/agence/planning/search/"+this.$store.state.user.agence.id+"/" + e.input, {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            },
          })
          .then((response) => {
            this.leleves = response.data.eleves;
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    selectItem(e) {
      window.api
        .get("one/eleve/exam/moniteur/" + e.id, {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          },
        })
        .then((response) => {
          if (response.data.eleve.length !== 0) {
            this.eleveSelec = response.data.eleve[0];
          } else {
            alert(
              "Vous ne pouvez pas effectuer de demande d'examen pour cet élève",
            );
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getElevesExamByMono() {
      window.api
        .get("/eleves/exam/moniteur/" + this.$store.state.user.idMono, {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          },
        })
        .then((response) => {
          this.eleves = response.data.eleves;
        })
        .catch((error) => {
          console.log(error.response.data.message);
        });
    },
  },
};
</script>

<style scoped>
div.background {
  background-color: #f4f6f9;
  min-height: 100vh;
  padding-bottom: 1rem;
}

/* DATATABLE STYLE */

/* Table wrapper */
:deep(.p-datatable) {
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  overflow: hidden;
  font-size: 14px;
}

/* Header */
:deep(.p-datatable .p-datatable-thead > tr > th) {
  background: #ffffff;
  color: #9ca3af;
  font-weight: 500;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  padding: 14px 20px;
  border-bottom: 1px solid #f3f4f6;
  border-right: none;
}

/* Rows */
:deep(.p-datatable .p-datatable-tbody > tr) {
  background: #ffffff;
  transition: background 0.15s;
}

:deep(.p-datatable .p-datatable-tbody > tr:hover) {
  background: #f9fafb;
}

:deep(.p-datatable .p-datatable-tbody > tr > td) {
  padding: 18px 20px;
  border-bottom: 1px solid #f3f4f6;
  border-right: none;
  color: #111827;
  font-size: 14px;
}

/* Nom en gras */
:deep(.p-datatable .p-datatable-tbody > tr > td:nth-child(2)) {
  font-weight: 600;
}

/* Suppression du style de sélection par défaut */
:deep(.p-datatable .p-datatable-tbody > tr.p-highlight) {
  background: #f0f9ff;
}

/* Paginator */
:deep(.p-paginator) {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-top: none;
  border-radius: 0 0 12px 12px;
  padding: 10px 16px;
}

:deep(.p-paginator .p-paginator-page.p-highlight) {
  background: #3b82f6;
  color: #ffffff;
  border-radius: 8px;
  border-color: #3b82f6;
}

:deep(.p-paginator .p-paginator-page),
:deep(.p-paginator .p-paginator-prev),
:deep(.p-paginator .p-paginator-next),
:deep(.p-paginator .p-paginator-first),
:deep(.p-paginator .p-paginator-last) {
  color: #6b7280;
  border: none;
  min-width: 32px;
  height: 32px;
  border-radius: 8px;
}

:deep(.p-paginator .p-paginator-page:hover:not(.p-highlight)),
:deep(.p-paginator .p-paginator-prev:hover),
:deep(.p-paginator .p-paginator-next:hover) {
  background: #f3f4f6;
}

div.greeting {
  width: 95%;
  margin: auto;
  text-align: left;
  margin-top: 1rem;
}

div.greeting h1 {
  margin: 0;
  font-weight: bold;
}

div.greeting p {
  color: #666666;
}

div.eleveSelec {
  margin-top: 3em;
  margin-bottom: 3em;
  display: flex;
  align-items: center;
  justify-content: space-around;
  background-color: white;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 20px;
  margin-bottom: 1rem;
}

.eleves-mono{
  width: 90%;
  margin: auto;
}

.simple-typeahead :deep(.simple-typeahead-list) {
  position: absolute;
  z-index: 9999;

  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  max-height: 300px;
  overflow-y: auto;
  margin: 0;
  padding: 0;
  list-style: none;
  left: 44%;
  width: 40%;
}

.simple-typeahead :deep(.simple-typeahead-list-item) {
  padding: 8px 12px;
  cursor: pointer;
  font-size: 14px;
}

.simple-typeahead :deep(.simple-typeahead-list-item:hover),
.simple-typeahead
  :deep(.simple-typeahead-list-item.simple-typeahead-list-item-active) {
  background-color: #f0f4ff;
}
</style>
